/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPH
 */
const Index = gql`
query CustomerAccountReadQuery($customerId: ID, $take: PositiveInt, $skip: Int,$filter: JSONObject )  {
  CustomerAccountRead(customerId: $customerId, take: $take, skip: $skip, filter: $filter) {
    id,
    message,
    status,
    batchId,
    Smpp {
        id,
        createdAt,
        updatedAt,
        isActive,
        displayName,
        batchId
        ip,
        txPort,
        rxPort,
        username,
        password,
        sessionTimeoutInterval,
        sessionAllowed,
        tps,
        debuggingLevel,
        message,
        status,
    },
    Account {
      email,
      displayName
    },
    _totalCount
  }
} 
`

/*
 * EXPORTS
 */
export default Index
